export class DashboardgetProcedures {
    constructor(

       public procedure_Id: number,
       public locationId: number,
       public patientID: number,
       public physicianID: number,
       public visitID: number,
       public procedureCode:string,
       public  procedureName: string,
       public prodcedureCodeType: string,
       public statusCode: string,
       public statusName: string,
       public statusCodeType: string,
       public note: string,
       public procedureNotDoneReasonCode: string,
       public procedureNotDoneReasonName: string,
       public procedureNotDoneReasonCodeType: string,
       public reasonType:string,
       public active: string,
       public  enteredBy: number,
       public   enteredDate: string,
       public  lastModifiedBy: number,
       public  lastModifiedDate: string,
       public  resolvedDate: string,
       public reason:string,
       public comments:string,
       public reasonforUpdate:string,
       public procedureDate:string,
       public siteName:string,
       public siteCode:string,
       public performer:string,
       public followUp:string,
       public performerNames:string,
       public scheduleSurgeon:string,
       public scheduletime :string,
       public  departmentId:number,
       public isPrimary:boolean
    ){}
}

